var map = {
	"./celebrate": 10125,
	"./celebrate.json": 10125,
	"./celebrate.svg": 14649,
	"./heart": 10126,
	"./heart.json": 10126,
	"./heart.svg": 14650,
	"./laugh": 10127,
	"./laugh.json": 10127,
	"./laugh.svg": 14651,
	"./like": 10128,
	"./like.json": 10128,
	"./like.svg": 14652,
	"./sad": 10129,
	"./sad.json": 10129,
	"./sad.svg": 14653,
	"./surprised": 10130,
	"./surprised.json": 10130,
	"./surprised.svg": 14654
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14648;